import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Listings.css';

// Component
import ListingManagement from '../../../components/siteadmin/ListingManagement';
import history from '../../../core/history';
import { parseRecentLimitFromUrl } from './listingsRecentLimit';
import { parseDocumentStatusFromUrl } from './listingsDocumentFilter';

class Listings extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      recentLimit: parseRecentLimitFromUrl(),
      documentStatusFilter: parseDocumentStatusFromUrl(),
    };
    this.setStateVariable = this.setStateVariable.bind(this);
    this.syncStateFromUrl = this.syncStateFromUrl.bind(this);
  }

  componentDidMount() {
    // Re-sync newest filter when URL changes (e.g. notification "See All" on same page).
    if (history) {
      this.unlisten = history.listen(this.syncStateFromUrl);
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  syncStateFromUrl() {
    // null recentLimit when query param removed ("All" → default oldest-first pagination).
    const recentLimit = parseRecentLimitFromUrl();
    const documentStatusFilter = parseDocumentStatusFromUrl();
    this.setState({
      recentLimit,
      documentStatusFilter,
      currentPage: 1,
    });
  }

  setStateVariable(variables) {
    this.setState(variables);
  }

  render() {
    const { currentPage, searchList, recentLimit, documentStatusFilter } = this.state;

    return (
      <ListingManagement
        currentPage={currentPage}
        searchList={searchList}
        recentLimit={recentLimit}
        documentStatusFilter={documentStatusFilter}
        setStateVariable={this.setStateVariable}
      />
    );
  }

}

export default compose(withStyles(s))(Listings);

